import React from 'react'
import styles from './style.module.scss'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const HeaderImg = ({ img, alt }) => {
  return (
    <header className={styles.header}>
      <img src={img} alt={alt ? alt : "header Img"} />
    </header>
  )
}

const HeaderCarousel = ({ images }) => {

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: false,
    arrows: false
  }

  return (
    <header className={styles.carousel}>
      <Slider {...settings}>
        {images.map((image, index) => (
          <div key={index}>
            <img src={image} alt="header image" />
          </div>
        ))}
      </Slider>
    </header>
  );
};


export { HeaderImg, HeaderCarousel }